import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { LetterOfAuthority, CreateLoaInput, PatchLoaInput, LoaStatus } from '@/types/api'

export function loaQueryKey(filters?: { status?: LoaStatus }) {
  return ['loa', filters] as const
}

export function useLoaItems(filters?: { status?: LoaStatus }) {
  return useQuery({
    queryKey: loaQueryKey(filters),
    queryFn: async () => {
      const params = new URLSearchParams()
      if (filters?.status) params.set('status', filters.status)
      const qs = params.size ? `?${params}` : ''
      return api.get<LetterOfAuthority[]>(`/loa${qs}`)
    },
  })
}

export function useCreateLoa() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateLoaInput) => api.post<LetterOfAuthority>('/loa', input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['loa'] })
    },
  })
}

export function usePatchLoa() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: PatchLoaInput }) =>
      api.patch<LetterOfAuthority>(`/loa/${id}`, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['loa'] })
    },
  })
}
